/**
 * SectionHeader
 *
 * Displays a title and optional subtitle for a page section.
 *
 * @props
 *  - title: string (required) → main section title
 *  - subtitle: string (optional) → section subtitle
 */

import React from 'react';
import './section-header.scss';

const SectionHeader = ({ title, subtitle }) => {
    return (
        <div className="section-header">
            {/* Main section title */}
            <h2 className="section-title">{title}</h2>
            {/* Optional subtitle, rendered only if provided */}
            {subtitle && <p className="section-subtitle">{subtitle}</p>}
        </div>
    );
};

export default SectionHeader;
